import { render, staticRenderFns } from "./TableMiniCart.vue?vue&type=template&id=0ac0c8dd&"
import script from "./TableMiniCart.vue?vue&type=script&lang=js&"
export * from "./TableMiniCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports